export class RenewalInfoResponse {
  constructor(
    public quoteId: string,
    public termDetails: TermDetails,
    public coverageDetails: CoverageDetails,
    public medEvac: MedEvac,
    public lossOfEarnings: LossOfEarnings,
    public exPatSecurityEvac: ExPatSecurityEvac,
    public travelSecurityEvac: TravelSecurityEvac,
    public enhancedExPatSecurityEvac: EnhancedExPatSecurityEvac,
    public enhancedTravelSecurityEvac: EnhancedTravelSecurityEvac,
    public childAbduction: ChildAbduction,
    public enhancedChildAbduction: EnhancedChildAbduction,
    public amendedAssetThreshold: AmendedAssetThreshold,
    public valueOfProducts: ValueOfProducts,
    public workplaceViolence: WorkplaceViolence,
  ){ }    
}
export class WorkplaceViolence {
  workplaceViolenceCoverage: string;
  perWorkplaceViolence?: any;
  annualAggregate?: any;
  maxBenefit?: any;
  aggPerWorkplaceViolence?: any;
}

export class ValueOfProducts {
  valueOfProductsCoverage: string;
  perInsuredEvent: string;
  annualAggregate: string;
}

export class AmendedAssetThreshold {
  amendedAssetThresholdCoverage: string;
  percentage: number;
}

export class EnhancedChildAbduction {
  enhancedChildAbductionCoverage: string;
  perChildAbduction: string;
  annualAggregate: string;
  legalFees: string;
  type: string;
}

export class ChildAbduction {
  childAbductionCoverage: string;
  perChildAbduction: string;
  annualAggregate: string;
  type: string;
}

export class EnhancedTravelSecurityEvac {
  enhancedTravelSecurityEvacCoverage: string;
  perTravelSecurityEvac: string;
  annualAggregate: string;
  personalEffects: string;
  repatriationCosts: string;
  unityFeesExpenses: string;
  excludedCountries: string;
}

export class EnhancedExPatSecurityEvac {
  enhancedExPatSecurityEvacCoverage: string;
  perExpatSecurityEvac?: any;
  annualAggregate?: any;
  personalEffects?: any;
  salary?: any;
  relocationCosts?: any;
  repatriationCosts?: any;
  unityFeesExpenses?: any;
  excludedCountries?: any;
}

export class TravelSecurityEvac {
  travelSecurityEvacCoverage: string;
  perTravelSecurityEvac?: any;
  annualAggregate?: any;
  personalEffects?: any;
  repatriationCosts?: any;
  unityFeesExpenses?: any;
  excludedCountries?: any;
}

export class ExPatSecurityEvac {
  exPatSecurityEvacCoverage: string;
  perExpatSecurityEvac: string;
  annualAggregate: string;
  personalEffects: string;
  salary: string;
  relocationCosts: string;
  repatriationCosts: string;
  unityFeesExpenses: string;
  excludedCountries: string;
}

export class LossOfEarnings {
  lossOfEarningsCoverage: string;
  perInsuredEvent: string;
  annualAggregate: string;
  indemnityPeriod: number;
  waitingPeriod: number;
}

export class MedEvac {
  medEvacCoverage: string;
}

export class CoverageDetails {
  limitOfInsurance: string;
  grossPremium: number;
  disappearanceAndInvestigation: string;
  threatResponse: string;
  recallResponse: string;
  ransom: string;
  ransomDeductible: string;
  personalBelongings: string;
  transit: string;
  legalLiability: string;
  additionalExpenses: string;
  crisisResponseFees: string;
  recallExpenses: string;
  aaForAllInsuredLosses: string;
  accidentalDAndDPerInsuredPerson: string;
  accidentalDAndDPerEvent: string;
  threatResponseExpense: string;
  threatAnnualAggregate: string;
  disappearanceInvestigationExpense: string;
  disappearanceAnnualAggregate: string;
}

export class TermDetails {
  termLength: string;
  effectiveDate: string;
  expirationDate: string;
}

